<template>
    <div
      class="negative-margined grid-standard col-span-full bg-grey-main py-2"
    >
      <SkeletonAnimatedPlaceholder
        height="16px"
        width="30%"
        borderRadius="8px"
        class="col-span-full"
      />
    </div>
</template>